/** Calendar day in the runtime's local time zone, e.g. "2026-8-16" (month is 0-based). */
export function localDayKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
}
